export { default as universalDesignSystem } from './universalDesignSystem';
export const popular = [{
  colors: ['#081DB3', '#9940BF', '#57A5C4', '#6AD2C8', '#73F74B', '#FDF551', '#ED6C2D', '#D62E1F'],
  name: 'Crayon Attack',
  category: ['popular']
}, {
  colors: ['#569FE5', '#EC6E85', '#6DBEBF', '#F2A354', '#9268F7', '#F7CF6B', '#C9CBCF'],
  name: 'Chart.js',
  category: ['popular']
}, {
  colors: ['#ef476f', '#ffd166', '#06d6a0', '#118ab2', '#073b4c', '#f07748', '#ffb300', '#049971', '#0d6c8b'],
  name: 'Vibrant Earth',
  category: ['popular']
}, {
  colors: ['#E13240', '#A72330', '#6E141F', '#37060F', '#000000'],
  name: 'Deep in the Red',
  category: ['popular']
}, {
  colors: ['#5CC397', '#CCFAB5', '#80E2D7', '#B4F5C3', '#ADF0AF'],
  name: 'Growth Phase',
  category: ['popular']
}, {
  colors: ['#B1C080', '#DEE5B9', '#EFEAD4', '#A3856B', '#69594E'],
  name: 'Yoda',
  category: ['popular']
}, {
  colors: ['#4F83F6', '#793DE3', '#EA336F', '#E7622C', '#F5C044'],
  name: 'Cold Start',
  category: ['popular']
}, {
  colors: ['#8CFADF', '#C0FCEE', '#E65F7C', '#EFA8B9', '#FBE5EB'],
  name: 'Positively Negative',
  category: ['popular']
}, {
  colors: ['#EE7B44', '#C46457', '#994D70', '#7A3A7C', '#59278A'],
  name: 'Plum Orange Smoothie',
  category: ['popular']
}, {
  colors: ['#7483E0', '#9185DD', '#B088DA', '#CE8CD7', '#EF8FD4'],
  name: 'Rising Dawn',
  category: ['popular']
}, {
  colors: ['#4EABE9', '#D92F8A', '#FCF150', '#747474', '#000000'],
  name: 'Printer Cartrige',
  category: ['popular']
}, {
  colors: ['#027CFF', '#59C3F5', '#FB9301', '#C0BFC5', '#E9E8EC'],
  name: 'Warmup',
  category: ['popular']
}, {
  colors: ['#E96A95', '#E96A95', '#F0B28D', '#F5D78C', '#FBFD8C'],
  name: 'Sunburn',
  category: ['popular']
}, {
  colors: ['#F2AA3C', '#ED6D67', '#AF578D', '#575089', '#173E59'],
  name: 'Retro Sunset',
  category: ['popular']
}];
export const monochromatic = [{
  colors: ['#31725A', '#33765D', '#3E8D6F', '#4AA380', '#6FD0B1'],
  name: 'Green',
  category: ['mono']
}, {
  colors: ['#5D0EF5', '#6B22F5', '#7B38F5', '#8B51F6', '#9A69F7'],
  name: 'Purple',
  category: ['mono']
}, {
  colors: ['#A42B17', '#DC3A22', '#EA3E25', '#F09685', '#F6CAC1'],
  name: 'Red',
  category: ['mono']
}, {
  colors: ['#F09235', '#F4B865', '#F7D097', '#FBE8CB', '#FDF1E1'],
  name: 'Orange',
  category: ['mono']
}, {
  colors: ['#F3CB45', '#F5D14C', '#F6D558', '#F6DB68', '#F8E07A'],
  name: 'Yellow',
  category: ['mono']
}, {
  colors: ['#EA7793', '#F095AB', '#F2A5B9', '#F4B6C6', '#F5BECC'],
  name: 'Pink',
  category: ['mono']
}, {
  colors: ['#367C99', '#3D85A0', '#4A91A9', '#5B9DB2', '#67A5B9'],
  name: 'Teal',
  category: ['mono']
}, {
  colors: ['#0F172A', '#334155', '#475569', '#64748B', '#94A3B8'],
  name: 'Gray',
  category: ['mono']
}, {
  colors: ['#2658F3', '#396AF3', '#4F7CF5', '#6790F5', '#80A2F6'],
  name: 'Blue',
  category: ['mono']
}];